import { gql } from '@apollo/client'
import { ADMIN_STORE_FRAGMENT } from '../fragments'

export const GET_ADMIN_STORE = gql`
  query GetAdminStore($storeId: ID!) {
    store(storeId: $storeId) {
      ...AdminStore
    }
  }
  ${ADMIN_STORE_FRAGMENT}
`
